import React from "react";
import { clsx } from "clsx";

import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LineShareButton,
  LineIcon,
  HatenaShareButton,
  HatenaIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";

interface ISnsShareBar extends React.PropsWithChildren {
  /**
   * Full URL of the page to share.
   */
  url: string;
}

export default function SnsShareBar(props: ISnsShareBar) {
  const { url } = props;

  return (
    <div
      className={clsx(
        "flex",
        "flex-col",
        "items-center",
        "lg:max-w-3xl",
        "md:max-w-2xl",
        "space-y-4",
        "w-full",
      )}
    >
      <p className={clsx("border-b-2", "border-primary", "font-bold")}>共有</p>
      <div
        className={clsx(
          "flex",
          "items-center",
          "justify-center",
          "space-x-4",
          "w-full",
        )}
      >
        <LineShareButton url={url}>
          <LineIcon className="w-10 sm:w-12" round />
        </LineShareButton>
        <EmailShareButton url={url}>
          <EmailIcon className="w-10 sm:w-12" round />
        </EmailShareButton>
        <FacebookShareButton url={url}>
          <FacebookIcon className="w-10 sm:w-12" round />
        </FacebookShareButton>
        <TwitterShareButton url={url}>
          <TwitterIcon className="w-10 sm:w-12" round />
        </TwitterShareButton>
        <HatenaShareButton url={url}>
          <HatenaIcon className="w-10 sm:w-12" round />
        </HatenaShareButton>
        <WhatsappShareButton url={url}>
          <WhatsappIcon className="w-10 sm:w-12" round />
        </WhatsappShareButton>
      </div>
    </div>
  );
}
